import * as React from 'react';
import IconBase, { type TIconBaseProps, Example as IconBaseExample } from '@atlas/uicorn/lib/Icon/IconBase';

const ShowMoreIcon = React.memo(function ShowMoreIcon(props: TShowMoreIconProps): React.ReactElement {
    return (
        <IconBase aria-label="Show More" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 6.5C11.8284 6.5 12.5 5.82843 12.5 5C12.5 4.17157 11.8284 3.5 11 3.5C10.1716 3.5 9.5 4.17157 9.5 5C9.5 5.82843 10.1716 6.5 11 6.5ZM12.5 11C12.5 11.8284 11.8284 12.5 11 12.5C10.1716 12.5 9.5 11.8284 9.5 11C9.5 10.1716 10.1716 9.5 11 9.5C11.8284 9.5 12.5 10.1716 12.5 11ZM12.5 17C12.5 17.8284 11.8284 18.5 11 18.5C10.1716 18.5 9.5 17.8284 9.5 17C9.5 16.1716 10.1716 15.5 11 15.5C11.8284 15.5 12.5 16.1716 12.5 17Z"
            />
        </IconBase>
    );
});

export default ShowMoreIcon;

// #region Types

export type TShowMoreIconProps = Omit<TIconBaseProps, 'children' | 'aria-label'> &
    Partial<Pick<TIconBaseProps, 'aria-label'>>;

// #endregion

// #region Examples

export const Example =
    typeof IconBaseExample === 'function' ? () => <ShowMoreIcon /> : { ...IconBaseExample, render: ShowMoreIcon };

// #endregion
